// extracted by css-extract-rspack-plugin
export default {"container":"container-u8hbip","appointmentTypeName":"appointmentTypeName-woj3uO"};